import React from 'react';

const HTML = () => {
  return (
    <div className="content-page">
      <h1>HTML Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is HTML?</h2>
        <p>HTML (HyperText Markup Language) is the standard markup language for creating Web pages.</p>
        <p>It describes the structure of a Web page and consists of a series of elements that tell the browser how to display the content.</p>
      </div>

      <div className="example">
        <h3>Example</h3>
        <div className="code-container">
          <pre>{`<!DOCTYPE html>
<html>
<head>
  <title>Page Title</title>
</head>
<body>
  <h1>My First Heading</h1>
  <p>My first paragraph.</p>
</body>
</html>`}</pre>
          <button className="try-it-btn">Try it Yourself »</button>
        </div>
      </div>

      <div className="tutorial-section">
        <h2>HTML Elements</h2>
        <p>An HTML element is defined by a start tag, some content, and an end tag:</p>
        <div className="code-container">
          <code>&lt;tagname&gt;Content goes here...&lt;/tagname&gt;</code>
        </div>
      </div>

      <div className="tutorial-section">
        <h2>HTML Page Structure</h2>
        <p>Here is a visualization of an HTML page structure:</p>
        <div className="code-container">
          <pre>{`<html>
  <head>
    <title>Page title</title>
  </head>
  <body>
    <h1>This is a heading</h1>
    <p>This is a paragraph.</p>
    <p>This is another paragraph.</p>
  </body>
</html>`}</pre>
        </div>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default HTML;
